import React from "react";
// import { Link } from "gatsby"
import { InterLinking } from "../../utils/Interlinking/interLinking";
import tw, { css } from "twin.macro";
import { Markdown } from "../../../utils/Markdown";

const CTAFour = ({ data, ...props }) => {
	return (
		<>
			{data ? (
				<section className="mt-20 mx-auto  max-w-screen-xl items-center mb-20 justify-between px-4">
					<div className="grid grid-cols-1 md:grid-cols-4 gap-6 divide divide-y">
						{data?.map((service, index) => {
							return (
								<div
									key={index}
									css={[
										props?.split
											? tw`col-span-1   md:col-span-2`
											: tw`col-span-1   md:col-span-4`,
										tw`shadow rounded p-6 outline outline-[3px] hover:outline-[3px] outline-blue-500/10 hover:outline-blue-500/60 outline-offset-[5px] hover:outline-offset-0 duration-300`,
										/* Combine regular css and Tailwind styles within backticks */
									]}
								>
									<h6 className="  text-xl text-black mb-2  ">
										{service?.node?.title
											? service?.node?.title
											: service?.title}
									</h6>
									<p className=" text-gray-500  tracking-wide ">
										<Markdown Output={service} />
									</p>
								</div>
							);
						})}
					</div>
				</section>
			) : null}
		</>
	);
};

export default CTAFour;
